<template>
  <section class="transparency">
    <div class="container">
      <div class="transparency-card reveal">
        <div class="card-inner">
          <div class="tag">The Roadmap</div>
          <h2>We're Building This <span>With You</span></h2>

          <div class="content-split">
            <div class="text-block reveal delay-1">
              <p class="lead-text">
                Bizzento already masters your
                <strong>daily operations</strong>—customer support, scheduling,
                and seamless communications.
              </p>
              <p>
                Now, we’re crafting the
                <strong>business intelligence engine</strong>. We aren't
                building this in a vacuum; we’re building it for the
                entrepreneurs who live it every day.
              </p>

              <div class="beta-callout">
                <span class="icon">🚀</span>
                <p>
                  <strong>Launching Q1 2026</strong> — We're looking for 10
                  visionary entrepreneurs to join our closed beta program.
                </p>
              </div>
            </div>

            <div class="perks-block reveal delay-2">
              <h3>Founder Perks:</h3>
              <ul class="benefits-list">
                <li>
                  <span class="check">✓</span>
                  Get early access to our Intelligence Suite
                </li>
                <li>
                  <span class="check">✓</span>
                  Shape the insights that drive your industry
                </li>
                <li>
                  <span class="check">✓</span>
                  Lock in permanent "Founding Member" pricing
                </li>
              </ul>

              <a href="#waitlist" class="cta-button">Join the Beta Program</a>
            </div>
          </div>
        </div>
        <div class="card-glow"></div>
      </div>
    </div>
  </section>
</template>
<style scoped>
.transparency {
  /* Theme Variables */
  --bg-warm-base: #f2eee0;
  --sunlight-glow: #faefca;
  --soft-gold: #f5e5b0;
  --dark-accent: #1a1a1a;
  --text-muted: #8e8a82;

  padding: 100px 24px;
  background-color: var(--bg-warm-base);
  color: var(--dark-accent);
}

.container {
  max-width: 1000px;
  margin: 0 auto;
}

.transparency-card {
  background: white;
  border-radius: 48px;
  padding: 12px;
  box-shadow: 0 30px 60px rgba(0, 0, 0, 0.05);
  position: relative;
  overflow: hidden;
}

.card-inner {
  padding: 60px;
  border-radius: 40px;
  border: 1px solid var(--soft-gold);
  background-image: radial-gradient(
    at 0% 0%,
    var(--sunlight-glow) 0%,
    transparent 40%
  );
}

.tag {
  display: inline-block;
  font-weight: 800;
  font-size: 0.75rem;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  color: #bfa14d;
  margin-bottom: 16px;
}

h2 {
  font-size: clamp(2rem, 4vw, 2.5rem);
  margin-bottom: 40px;
  line-height: 1.2;
}

h2 span {
  color: #bfa14d;
}

.content-split {
  display: grid;
  grid-template-columns: 1.2fr 1fr;
  gap: 60px;
  text-align: left;
}

.lead-text {
  font-size: 1.25rem;
  margin-bottom: 20px;
  line-height: 1.6;
}

.text-block p {
  color: var(--text-muted);
  line-height: 1.7;
}

.beta-callout {
  margin-top: 40px;
  display: flex;
  gap: 16px;
  align-items: center;
  background: var(--sunlight-glow);
  padding: 20px;
  border-radius: 20px;
  border: 1px dashed #bfa14d;
}

.beta-callout p {
  margin: 0;
  color: var(--dark-accent) !important;
  font-size: 0.95rem;
}

.perks-block h3 {
  font-size: 1.1rem;
  margin-bottom: 24px;
}

.benefits-list {
  list-style: none;
  padding: 0;
  margin: 0 0 40px 0;
}

.benefits-list li {
  display: flex;
  gap: 12px;
  margin-bottom: 16px;
  font-weight: 600;
  font-size: 1rem;
}

.check {
  color: #bfa14d;
}

.cta-button {
  display: block;
  text-align: center;
  background: var(--dark-accent);
  color: white;
  padding: 18px;
  border-radius: 12px;
  text-decoration: none;
  font-weight: 700;
  transition: transform 0.2s;
}

.cta-button:hover {
  transform: scale(1.02);
}

@media (max-width: 850px) {
  .content-split {
    grid-template-columns: 1fr;
    gap: 40px;
  }
  .card-inner {
    padding: 40px 24px;
  }
}
</style>
<script>
export default {
  name: 'TransparencySection',
};
</script>
